import { Component, Input, TemplateRef } from '@angular/core';
import { DropdownFieldModel } from '../../../index';
import { NgTemplateOutlet } from '@angular/common';
import { Select } from 'primeng/select';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'shared-ui-dynamic-form-dropdown',
  imports: [NgTemplateOutlet, Select, ReactiveFormsModule],
  template: `
    @if (template) {
      <ng-container
        [ngTemplateOutlet]="template"
        [ngTemplateOutletContext]="{ fieldModel }"></ng-container>
    } @else {
      <p-select
        [formControl]="fieldModel.control!"
        [options]="fieldModel.options"
        optionLabel="value"
        placeholder="Select a City"
        class="w-full md:w-56" />
    }
  `,
  styles: ``,
})
export class DynamicFormDropdownComponent {
  @Input() template?: TemplateRef<unknown>;
  @Input({ required: true }) fieldModel!: DropdownFieldModel;
}
